<div class="editor-header">
  <div class="editor-heading">
    <div class="editor-heading-title">
      <mat-icon>volunteer_activism</mat-icon>
      <span>{{ title }}</span>
    </div>
    <p>Registra o modifica una colaboración del miembro.</p>
  </div>
</div>

<div class="event-summary-layout">
  <div class="events-summary">
    <div class="events-summary__title">Colaboraciones registradas</div>
    <table class="events-summary__table">
      <thead>
        <tr>
          <th>Desde</th>
          <th>Hasta</th>
          <th>Actividad</th>
          <th>Unidad</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let event of visibleActivityEvents" [class.events-summary__row--current]="!event.endDate">
          <td>{{ formatDate(event.eventDate) }}</td>
          <td>{{ event.endDate ? formatDate(event.endDate) : '-' }}</td>
          <td>{{ event.eventTypeName }}</td>
          <td>{{ event.organizationUnitName || '-' }}</td>
        </tr>
        <tr *ngIf="!visibleActivityEvents.length" class="events-summary__empty">
          <td colspan="4">Sin colaboraciones registradas</td>
        </tr>
      </tbody>
    </table>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="editor-form">
  <div class="form-grid">
    <app-date-picker
      label="Fecha de inicio"
      formControlName="eventDate"
      [errorMessages]="{ required: 'Requerida' }">
    </app-date-picker>
    <app-optional-field
      [formControls]="form.get('endDate')!"
      triggerLabel="Agregar fecha de finalización"
      removeTooltip="Quitar fecha de finalización">
      <app-date-picker label="Fecha de finalización" formControlName="endDate"></app-date-picker>
    </app-optional-field>

    <mat-form-field>
      <mat-label>Actividad</mat-label>
      <mat-select formControlName="activityId">
        <mat-option *ngFor="let option of availableActivities" [value]="option.id">
          {{ option.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('activityId')?.hasError('required')">Requerida</mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="selectedActivityHasRoles">
      <mat-label>Rol</mat-label>
      <mat-select formControlName="activityRoleId">
        <mat-option *ngFor="let option of filteredActivityRoles" [value]="option.id">
          {{ option.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('activityRoleId')?.hasError('required')">Requerido</mat-error>
    </mat-form-field>

    <app-unit-selector
      class="field-full"
      [defaultUnitName]="defaultUnitName"
      [unitSource]="'all'"
      [allowDefaultUnit]="true"
      [groupByLevel]="true"
      groupByMode="level"
      formControlName="organizationUnitId">
    </app-unit-selector>

    <app-optional-field
      class="field-full"
      [formControls]="form.get('notes')!"
      triggerLabel="Agregar notas"
      removeTooltip="Quitar notas">
      <mat-form-field class="field-full">
        <mat-label>Notas</mat-label>
        <textarea matInput rows="4" formControlName="notes"></textarea>
      </mat-form-field>
    </app-optional-field>
  </div>

  <div class="form-actions">
    <button mat-button type="button" (click)="onCancel()">Cancelar</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="isSaving">
      <mat-icon>{{ currentEvent ? 'save' : 'add' }}</mat-icon>
      <span *ngIf="!isSaving">{{ currentEvent ? 'Guardar cambios' : 'Guardar' }}</span>
      <span *ngIf="isSaving">Guardando...</span>
    </button>
  </div>
  </form>
</div>
